import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { H2, H3, Image, Container, H1 } from '/components/atoms';
import { PSPMarkdownContent } from 'components/molecules';

import './SectionHeader.scss';

function SectionHeader({
	className,
	image,
	prefix,
	title,
	titleProps,
	suffix,
	description,
	contentAlign = 'text-center',
	additionalProps,
}) {
	return (
		<div className={classnames(className, 'section-header', contentAlign)}>
			<Container>
				{image && (
					<Image
						className="section-header-img"
						src={image}
						alt={title}
					/>
				)}

				{prefix && (
					<PSPMarkdownContent
						content={prefix}
						additionalProps={{
							heading: { className: 'subheading prefix' },
						}}
					/>
				)}

				{prefix && title && !additionalProps?.isSizeGuideHeader && (
					<H3
						size="large"
						className={classnames('section-header-title')}
						{...titleProps}
					>
						{title}
					</H3>
				)}
				{!additionalProps?.isSizeGuideHeader && !prefix && title && (
					<H2
						size="large"
						className={classnames('section-header-title')}
						{...titleProps}
					>
						{title}
					</H2>
				)}
				{additionalProps?.isSizeGuideHeader && title && (
					<H1
						size="xlarge"
						className={classnames('section-header-title')}
						{...titleProps}
					>
						{title}
					</H1>
				)}

				{suffix && (
					<PSPMarkdownContent
						content={suffix}
						additionalProps={{
							heading: { className: 'subheading suffix' },
							paragraph: { className: 'subheading' },
						}}
					/>
				)}

				{description && (
					<PSPMarkdownContent
						content={description}
						additionalProps={{ ...additionalProps }}
					/>
				)}
			</Container>
		</div>
	);
}

SectionHeader.propTypes = {
	className: PropTypes.string,
	image: PropTypes.string,
	prefix: PropTypes.string,
	title: PropTypes.string,
	suffix: PropTypes.string,
	description: PropTypes.string,
	contentAlign: PropTypes.oneOf(['text-left', 'text-center']),
	titleProps: PropTypes.object,
	additionalProps: PropTypes.object,
};

export default SectionHeader;
